import _ from 'lodash';
import { getColor } from '../../../Map/drawing';

export const merge_regional_data = (attrs = {}, filteringState) => {
  const {
    regional_info,
    partners_update,
    partner_transactions_summary
  } = attrs;
  if (!regional_info) return null;
  if (filteringState.partner_update && !partners_update) return null;
  if (filteringState.partner_transaction && !partner_transactions_summary)
    return null;
  return regional_info.map(info => {
    const partner_update = _.find(partners_update, { id: info.id });
    const partner_transactions = _.find(partner_transactions_summary, {
      id: info.id
    });
    return { ...info, ...partner_update, ...partner_transactions };
  });
};

export const merge_regional_marker_data = (attrs = {}) => ({
  partners: attrs.partners,
  partners_with_transaction: attrs.partners_with_transaction
});

const get_choropleth_density_by_state = (
  regional_info,
  filteringState,
  extraOption = {}
) => {
  if (filteringState.partner_update) {
    const { info_list } = extraOption;
    const min = Math.min(...info_list.map(info => info.new_partner));
    const max = Math.max(...info_list.map(info => info.new_partner));
    return (regional_info.new_partner - min) / (max - min);
  } else if (filteringState.partner_transaction) {
    const { info_list } = extraOption;
    const min = Math.min(...info_list.map(info => info.current_total_amount));
    const max = Math.max(...info_list.map(info => info.current_total_amount));
    return (regional_info.current_total_amount - min) / (max - min);
  }
  return 1;
};

export const make_choropleth = (map, info_list, filteringState) => {
  if (!map) return;
  return {
    type: 'FeatureCollection',
    features: map.map(geo => {
      const info = _.find(info_list, { map: geo.id });
      return {
        type: 'Feature',
        properties: {
          ...info,
          density: get_choropleth_density_by_state(info, filteringState, {
            info_list
          })
        },
        center: geo.center,
        geometry: geo.geo_json
      };
    })
  };
};

const make_label_str_by_state = (label_info, filteringState) => {
  let label = `${label_info.name}<br>`;
  if (filteringState.partner_update) {
    label += `${label_info.new_partner}, ${label_info.active_partner}, ${label_info.total_partner}`;
  } else if (filteringState.partner_transaction) {
    label += `${(label_info.current_total_amount / 100000).toFixed(2)}L, ${(
      label_info.previous_total_amount / 100000
    ).toFixed(2)}L`;
  }
  return label;
};

export const make_label_by_state = (map, label_info, filteringState) => {
  if (!map) return;
  return {
    type: 'FeatureCollection',
    features: map.map(geo => {
      const info = _.find(label_info, { map: geo.id });
      return {
        type: 'Feature',
        properties: {
          density: make_label_str_by_state(info, filteringState)
        },
        geometry: {
          type: 'Point',
          coordinates: [geo.center.lng, geo.center.lat]
        }
      };
    })
  };
};

export const make_boundary = map => {
  if (!map) return;
  return {
    type: 'Feature',
    geometry: map.geo_json
  };
};

export const make_legends_by_state = filteringState => {
  var grades = [0, 10, 20, 30, 40, 50, 60, 70, 80, 90, 100];
  var innerHTML = '';
  if (filteringState.partner_update) {
    innerHTML = '<strong>Count-wise Percentile</strong>';
  } else if (filteringState.partner_transaction) {
    innerHTML = '<strong>Payment-wise Percentile</strong>';
  }
  for (var i = 0; i < grades.length; i++) {
    innerHTML +=
      '<div class="block"><i style="background:' +
      getColor(grades[i] / 100) +
      '"></i> ' +
      grades[i] +
      (grades[i + 1] ? '&ndash;' + (grades[i + 1] - 1) + '<br>' : '') +
      '</div>';
  }
  return innerHTML;
};

export const make_summary_by_state = (regional_info, filteringState) => {
  if (filteringState.partner_update) {
    const total_new_partner = regional_info.reduce(
      (total, info) => total + info.new_partner,
      0
    );
    const total_active_partner = regional_info.reduce(
      (total, info) => total + info.active_partner,
      0
    );
    const total_partner = regional_info.reduce(
      (total, info) => total + info.total_partner,
      0
    );
    return `${total_new_partner}, ${total_active_partner}, ${total_partner}`;
  }
  if (filteringState.partner_transaction) {
    const current_total_amount = regional_info.reduce(
      (total, info) => total + info.current_total_amount,
      0
    );
    const previous_total_amount = regional_info.reduce(
      (total, info) => total + info.previous_total_amount,
      0
    );
    return `${(current_total_amount / 100000).toFixed(2)}L, ${(
      previous_total_amount / 100000
    ).toFixed(2)}L`;
  }
  return '';
};

const make_partner_marker_info = partner => ({
  ...partner,
  tooltip: `
    <strong>Name:</strong> ${partner.name} </br>
    <strong>Registration Date:</strong> ${partner.registration_date} </br>
    <strong>Mobile Number:</strong> ${partner.mobile_number}
  `
});

const make_partner_transaction_marker_info = partner => ({
  ...partner,
  tooltip: `
    <strong>Name:</strong> ${partner.name} </br>
    <strong>Total Disbursed Amount:</strong> ${partner.total_disbursed_amount} </br>
    <strong>Total Collection Amount:</strong> ${partner.total_collection_amount}
  `
});

export const make_markers_by_state = (data, filteringState) => {
  const partners = data.partners
    .filter(partner => partner.location != null)
    .map(partner => make_partner_marker_info(partner));

  const partners_with_transaction = data.partners_with_transaction
    .filter(partner => partner.location != null)
    .map(partner => make_partner_transaction_marker_info(partner));

  let markers = [];
  if (filteringState.partner_update) markers = partners;
  else if (filteringState.partner_transaction)
    markers = partners_with_transaction;

  return markers;
};
